import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.501.834v1.667h5V.834h1.667v1.667h3.333c.46 0 .834.373.834.833v13.333c0 .46-.373.834-.834.834h-15a.833.833 0 0 1-.833-.834V3.334c0-.46.373-.833.833-.833h3.334V.834zm9.167 8.333H3.335v6.667h13.333zm-10.833-5h-2.5v3.334h13.333V4.167h-2.5v1.667h-1.667V4.167h-5v1.667H5.835z"
    }, null, -1)
  ]))]))
}
export default { render: render }